import { debounce } from 'lodash';
import { useLayoutEffect, useMemo, useRef } from 'react';

/**
 * https://www.epicreact.dev/the-latest-ref-pattern-in-react
 *
 * extension on the Lodash debounce utility, for use within components.
 * Saves the callback function as a React ref to save it's value during
 * re-rendering, preventing the debounce hook from re-initializing each time
 */
const useDebounce = <T extends unknown[]>(
  callback: (...args: T) => void,
  delay: number
) => {
  const callbackRef = useRef(callback);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(
    () => debounce((...args: T) => callbackRef.current(...args), delay),
    [delay]
  );
};

export { useDebounce };
